<template v-if="$store.state.authStore.isAuthenticated">
  <q-layout view="hHh LpR lFf">
    <!-- Header -->
    <q-layout-header>
      <!-- First row of header is a QToolbar -->
      <q-toolbar color="neutral">
        <!-- showLeft is a model attached to left side drawer below -->
        <q-btn
          :class="{ active: !miniNav }"
          color="grey-5"
          size="lg"
          flat
          dense
          round
          @click="toggleDrawer();"
          aria-label="Menu"
          icon="menu"
        />
        <q-toolbar-title class="text-grey">
          <div class="row">
            {{ getString(`module.name.${$route.meta.title}`) | capitalize }}
            <div v-if="$route.meta.action">
              &nbsp;
              <span class="subtitle">
                | {{ getString(`action.${$route.meta.action}`).toUpperCase() }}
              </span>
            </div>
          </div>
        </q-toolbar-title>

        <!-- right side of toolbar -->

        <!-- Help button for opening right drawer -->
        <q-btn
          round
          color="warning"
          icon="help_outline"
          class="help-button"
          @click="drawerRight = !drawerRight"
        />

        <!-- User nav -->
        <div
          v-ripple="true"
          class="toolbar-menu relative-position"
        >
          <span class="toolbar-menu-item">
            <p>{{ activeWebsite }}</p>
            <q-icon
              size="large"
              name="chevron_right"
            />
          </span>
          <q-popover
            v-model="showContextPopover"
            anchor="bottom middle"
            self="top middle"
          >
            <q-list
              link
              v-for="(website, i) in $store.state.meStore.me.websites"
              :key="`${website}-${i}`"
            >
              <q-item
                class="toolbar-list-item"
                @click.native="changeWebsite(website)"
              >
                <q-icon
                  :color="isActive(website)"
                  size="large"
                  name="check"
                />
                {{ website.name }}
              </q-item>
            </q-list>
          </q-popover>
        </div>
        <div
          v-ripple="true"
          class="toolbar-menu relative-position"
        >
          <span class="toolbar-menu-item q-mr-sm">
            <img
              v-if="!avatarError"
              :src="userAvatar($store.state.meStore.me.avatar)"
              @error="avatarError = true"
              class="gravatar"
              alt=""
            >
            <img
              v-else
              :src="`${base_url}default-avatar.jpeg`"
              class="gravatar"
            >
            <p>{{ fullname }}</p>
            <q-icon
              size="large"
              name="chevron_right"
            />
          </span>
          <q-popover
            v-model="showUserPopover"
            anchor="bottom middle"
            self="top middle"
          >
            <q-list link>
              <q-item
                class="toolbar-list-item"
                @click.native="gotoRoute('/profile')"
              >
                <q-icon
                  color="positive"
                  size="large"
                  name="person"
                />
                Profile
              </q-item>
              <q-item
                class="toolbar-list-item"
                @click.native="logout()"
              >
                <q-icon
                  color="secondary"
                  size="large"
                  name="power_settings_new"
                />
                Log out
              </q-item>
            </q-list>
          </q-popover>
        </div>
      </q-toolbar>
    </q-layout-header>

    <!-- Left Side Drawer -->
    <q-layout-drawer
      :width="234"
      v-model="drawer"
      :mini="miniNav"
      @mouseover="miniNav = false;"
      @mouseout="miniNav = hide;"
    >
      <q-list
        no-border
        link
        class="menu-left"
        inset-delimiter
      >
        <div
          v-for="(menuItem, i) in $store.state.navigationStore.menuItems"
          @click="viewMenuItem(menuItem)"
          :key="`${menuItem}-${i}`"
        >
          <!-- Render non-collapseable menu items -->
          <q-item
            v-if="menuItem.type === 'module'"
            v-ripple
            :to="`/${path(menuItem.state)}`"
            :class="{ 'active-menu-item': activeMenuItem === path(menuItem.state) }"
          >
            <q-item-side :icon="mapIcon(menuItem.icon)" />
            <q-item-main :label="getString(menuItem.label)" />
          </q-item>
          <!-- Render collapsable menu categories -->
          <q-collapsible
            v-else-if="menuItem.type === 'category'"
            :icon="mapIcon(menuItem.icon)"
            :label="getString(menuItem.label)"
            v-model.lazy="items[menuItem.label]"
            :class="{ 'active-menu-item': collapsableIncludes(menuItem.modules) }"
          >
            <!-- Render nested menu items -->
            <q-item
              v-for="(subModule, i) in menuItem.modules"
              :key="`${subModule}-${i}`"
              v-ripple
              :to="`/${path(subModule.state)}`"
              exact
              :class="{ 'active-menu-sub-item': activeMenuItem === path(subModule.state) }"
            >
              <q-item-side />
              <q-item-main :label="getString(subModule.label)" />
            </q-item>
          </q-collapsible>
        </div>
      </q-list>
    </q-layout-drawer>

    <!-- sub-routes get injected here: -->
    <q-page-container>
      <q-page padding>
        <router-view />
      </q-page>
    </q-page-container>

    <q-layout-drawer
      side="right"
      v-model="drawerRight"
    >
      <!-- The help component -->
      <HelpDrawer></HelpDrawer>
    </q-layout-drawer>

  </q-layout>
</template>

<script>
import { openURL } from 'quasar';
import getString from '@/helpers/GetStrings';
import HelpDrawer from '../modules/help/HelpDrawer.vue';

export default {
  name: 'LayoutDefault',
  created () {
    this.$store.state.navigationStore.menuItems.forEach((element) => {
      const sub = element.modules ? element.modules.map(i => this.path(i.state)) : [];

      if (sub.includes(this.activeMenuItem)) {
        // Show the active item open at creation
        this.$set(this.items, element.label, true);
      } else {
        this.$set(this.items, element.label, false);
      }
    });

    // Catch closeRightDrawer-event to close right drawer
    this.$root.$on('closeRightDrawer', this.closeRightDrawer);

    this.$store.dispatch('getHelp');
    this.$store.dispatch('getMe')
      .then(() => {
        this.$store.dispatch('getNavigation');
      })
      .catch((error) => {
        console.warn(error.message);
      });
  },
  components: {
    HelpDrawer,
  },
  data () {
    return {
      items: {},
      avatarError: false,
      base_url: process.env.BASE_URL,
      icons: {
        dashboard: 'dashboard',
        usergroups: 'people',
        developer: 'code',
        library: 'library_books',
        blog: 'art_track',
        news: 'import_contacts',
        press: 'camera',
        master: 'select_all',
        error: 'error_outline',
        faq: 'question_answer',
        page: 'web',
        hub: 'mdi-hexagon-multiple',
        product: 'devices_other',
        branch: 'mdi-source-branch',
        reference: 'domain',
        navigation: 'mdi-file-tree',
        content: 'toc',
        service: 'mdi-lifebuoy',
        event: 'date_range',
        popup: 'announcement',
        marketing: 'mdi-bullhorn',
        'spare-parts': 'build',
        form: 'view_list',
        // service: 'support_agent',
      },
      drawer: true,
      drawerRight: false,
      miniNav: false,
      hide: false,
      showContextPopover: false,
      showUserPopover: false,
      openItem: {},
    };
  },
  computed: {
    activeWebsite () {
      return this.$store.state.navigationStore.activeWebsite.name;
    },

    activeMenuItem () {
      // return dashboard as active item when in root path.
      if (this.$route.path === '/') {
        return 'dashboard';
      }
      // Return the root path, eg. ".../about/1" returns "about"
      return this.$route.path.split('/')[1];
    },
    fullname () {
      // Filter out null values and return full name
      return [
        this.$store.state.meStore.me.name ? this.$store.state.meStore.me.name.firstname : null,
        this.$store.state.meStore.me.name ? this.$store.state.meStore.me.name.surname : null,
      ].filter(val => val !== null).join(' ');
    },
  },
  methods: {
    getString,
    openURL,
    userAvatar (path) {
      return path && path.includes('www.gravatar.com') ? path : `${process.env.VUE_APP_API_URL}${path}`;
    },

    viewMenuItem (menuItem) {
      for (const key in this.items) {
        // eslint-disable-next-line no-prototype-builtins
        if (this.items.hasOwnProperty(key) && key !== menuItem.label) {
          this.items[key] = false;
        }
      }
    },
    path (state) {
      return state.split('.').pop();
    },
    gotoRoute (route) {
      this.$router.push(route);
    },
    mapIcon (icon) {
      return this.icons[icon] ? this.icons[icon] : this.icons.error;
    },
    toggleDrawer () {
      // Ensure draw is able to open on mobile
      this.drawer = true;
      this.hide = !this.hide;
      this.miniNav = this.hide;
    },
    // collapsableIncludes is used to apply a class to the parent item in a collapsable menu item.
    collapsableIncludes (modules) {
      // childItems is an array of the nested items inside the collapsible menu item.
      const childItems = modules.map(item => item.label.split('.').pop());

      // Exceptions for these module names
      if (this.activeMenuItem === 'category') {
        return childItems.includes('categories');
      }

      if (this.activeMenuItem === 'tag') {
        return childItems.includes('tags');
      }

      return childItems.includes(this.activeMenuItem);
    },
    changeWebsite (website) {
      this.$store.dispatch('changeWebsite', website)
        .then(() => {
          this.$router.push('/dashboard');
        });
    },
    userAction () {
      this.showUserPopover = false;
    },
    isActive (website) {
      return website.name === this.activeWebsite ? 'primary' : 'grey-4';
    },
    logout () {
      this.$router.push('/login');
      this.$store.dispatch('authLogout');
    },
    closeRightDrawer () {
      this.drawerRight = false;
    },
  },
  filters: {
    capitalize (value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  watch: {
    miniNav () {
      this.$root.$emit('changeNav');
    },
    drawerRight (val) {
      if (val === true) this.$root.$emit('setHelp');
    },
    $route () {
      // Emit event to set the right help content
      this.$root.$emit('setHelp');
      this.drawerRight = false;
    },
  },
  mounted () {
    this.$root.$on('me:avatar-update', () => {
      this.avatarError = false;
    });
  },
  destroyed () {
    this.$root.$off('me:avatar-update');
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables';

.gravatar {
  display: inline-block;
  height: 2.1rem;
  width: 2.1rem;
  margin: 0.85rem 1rem 0 0;
  border-radius: 50%;
  object-fit: cover;
}

.subtitle {
  font-weight: 600;
  font-size: 70%;
  color: $ctrl-grey-darken-2;
}

.hide-scroll {
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
